import { useEffect, useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const EditResearcherProfile = ({ open, setOpen ,fetchResearcher}) => {
  const [loading, setLoading] = useState(false);

  const [answers, setAnswers] = useState({
    research_interests: "",
    has_active_project: null,
    research_type: "",
  });

  const handleChange = (key, value) => {
    setAnswers((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ✅ GET /me when modal opens
  useEffect(() => {
    if (!open) return;

    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/researcher/me`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        if (res.ok) {
          const response = await res.json();
          const data=response?.researcher
          setAnswers({
            research_interests: data?.answers?.research_interests || "",
            has_active_project: data?.answers?.has_active_project,
            research_type: data?.answers?.research_type || "",
          });
        }
      } catch (err) {
        console.error("Failed to load profile", err);
      }
    };

    fetchProfile();
  }, [open]);

  // ✅ PUT update
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/marketplace/researcher/create-researcher-profile/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
        body: JSON.stringify({ answers }),
      });

      if (res.ok) {
        alert('Researcher updated successfully')
        fetchResearcher()
        setOpen(false);
      } else {
        console.error("Update failed");
      }
    } catch (err) {
      console.error("Error updating profile", err);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
  <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl">
    {/* Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Edit Research Preferences</h2>
            <p className="text-sm text-gray-500 mt-0.5">Update your research interests</p>
          </div>
        </div>
        <button 
          onClick={() => setOpen(false)}
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
        >
          <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    {/* Form Content */}
    <div className="p-6">
      <div className="space-y-6">
        {/* Question 1 */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-semibold text-gray-700">
              What are your current research interests?
            </label>
          </div>
          <input
            type="text"
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            value={answers.research_interests}
            onChange={(e) =>
              handleChange("research_interests", e.target.value)
            }
          />
        </div>

        {/* Question 2 */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <p className="text-sm font-semibold text-gray-700">
              Active research project?
            </p>
          </div>
          <div className="flex gap-6">
            <label className="flex items-center gap-2">
              <div className="relative">
                <input
                  type="radio"
                  checked={answers.has_active_project === true}
                  onChange={() => handleChange("has_active_project", true)}
                  className="sr-only"
                />
                <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                  answers.has_active_project === true 
                    ? 'border-[#0f6abf]' 
                    : 'border-gray-300'
                }`}>
                  {answers.has_active_project === true && (
                    <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
                  )}
                </div>
              </div>
              <span className="text-sm text-gray-700">Yes</span>
            </label>

            <label className="flex items-center gap-2">
              <div className="relative">
                <input
                  type="radio"
                  checked={answers.has_active_project === false}
                  onChange={() => handleChange("has_active_project", false)}
                  className="sr-only"
                />
                <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                  answers.has_active_project === false 
                    ? 'border-[#0f6abf]' 
                    : 'border-gray-300'
                }`}>
                  {answers.has_active_project === false && (
                    <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
                  )}
                </div>
              </div>
              <span className="text-sm text-gray-700">No</span>
            </label>
          </div>
        </div>

        {/* Question 3 */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <p className="text-sm font-semibold text-gray-700">
              Research type
            </p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {["theoretical", "applied", "experimental", "interdisciplinary"].map(
              (type) => (
                <label key={type} className="flex items-center gap-2">
                  <div className="relative">
                    <input
                      type="radio"
                      checked={answers.research_type === type}
                      onChange={() => handleChange("research_type", type)}
                      className="sr-only"
                    />
                    <div className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                      answers.research_type === type 
                        ? 'border-[#0f6abf]' 
                        : 'border-gray-300'
                    }`}>
                      {answers.research_type === type && (
                        <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>
                      )}
                    </div>
                  </div>
                  <span className="text-sm text-gray-700 capitalize">{type}</span>
                </label>
              )
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="pt-6 border-t border-gray-100">
          <div className="flex gap-3">
            <button
              onClick={() => setOpen(false)}
              className="flex-1 py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 py-2.5 bg-[#0f6abf] text-white rounded-xl text-sm font-medium hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default EditResearcherProfile;
